const CONTACT_KEYS = ["email", "first_name"];
// Socio-demo answers are keyed by preset, which names the same question in every discussit.
const SOCIODEMO_PREFIX = "sociodemo_";
// Opt-ins are keyed by record id, which does not.
const OPT_IN_PREFIX = "optin_";

export function prefillAnswers({ sameDiscussit = {}, mostRecent = {} }) {
  return {
    ...filledAnswers(mostRecent, shouldKeepAcross),
    ...filledAnswers(sameDiscussit, shouldKeepWithin),
  };
}

function shouldKeepAcross(key) {
  return CONTACT_KEYS.includes(key) || key.startsWith(SOCIODEMO_PREFIX);
}

function shouldKeepWithin(key) {
  return shouldKeepAcross(key) || key.startsWith(OPT_IN_PREFIX);
}

// Blanks are skipped so a cleared answer falls through to an earlier one
// instead of overwriting it with nothing.
function filledAnswers(answers, shouldKeep) {
  return Object.fromEntries(
    Object.entries(answers).filter(
      ([key, value]) => shouldKeep(key) && isFilled(value),
    ),
  );
}

function isFilled(value) {
  if (Array.isArray(value)) return value.length > 0;

  return value !== null && value !== undefined && value !== "";
}
